import { BottomBar } from '@sales-app/views'
import React from 'react'

import { useUserContext } from '@/context'
import { AgentRoles } from '@/context/user/user.types'

import { AgentDashboard } from './AgentDashboard/AgentDashboard'
import { ManagerDashboard } from './SupervisorDashboard/SupervisorDashboard'

export const Dashboard = () => {
  const { user } = useUserContext()
  const supervisorView = user?.agent?.role === AgentRoles.SUPERVISOR || false
  return (
    <>
      <div className="flex max-h-screen w-full flex-col overflow-y-scroll p-4 md:p-8">
        <h1 className="mb-3 text-header-lg">{supervisorView ? 'Supervisor' : 'Agent'} Dashboard</h1>
        {supervisorView ? (
          <ManagerDashboard />
        ) : (
          <div>
            <AgentDashboard />
          </div>
        )}
      </div>
      <BottomBar />
    </>
  )
}
